import type { ModuleManifest } from '../types';
import { COLLECTIONS } from '../../config/collections';
import { routes } from './routes';
import { navItems } from './nav';

const shopModule: ModuleManifest = {
  id: 'SHOP',
  name: 'Shop',
  shortName: 'Shop',
  description: 'In-shop service and repair jobs: intake, evidence, approvals, work log and billing handoff',
  icon: 'Warehouse',
  status: 'in_development',
  urlPrefix: '/shop',
  routes,
  navItems,
  collections: {
    SHOP_CASES: COLLECTIONS.SHOP_CASES,
    SHOP_LOCATIONS: COLLECTIONS.SHOP_LOCATIONS,
  },
};

export default shopModule;
